import React from 'react'
import Link from 'gatsby-link'
import { Container, Row, Col, Nav, NavItem, NavLink } from 'reactstrap'

const Footer = () => 
  <div>
    <div className="border-top py-5 bg evelope">
      <Container>
        <Row>
          <Col className="text-center">
            <h4>Sprechen wir über Ihr Projekt. Ich freue mich über Ihren Anruf unter <a href="tel:+436641455590">+43 664 14 555 90</a>.</h4>
          </Col>
        </Row>
      </Container>
    </div>

    <footer className="bg-dark text-light py-5 py-lg-7">
      <Container>
        <Row className="pb-5">
          <Col sm="6" md="3">
            <Nav vertical>
              <NavItem>
                <NavLink tag={Link} to="/leistungen" className="font-weight-bold">Leistungen</NavLink>
              </NavItem>
              <NavItem>
                <NavLink tag={Link} to="/leistungen">Webapplikationen</NavLink>
              </NavItem>
              <NavItem>
                <NavLink tag={Link} to="/leistungen">Webseiten</NavLink>
              </NavItem>
              <NavItem>
                <NavLink tag={Link} to="/leistungen">Anwendungssoftware</NavLink>
              </NavItem>
            </Nav>
          </Col>

          <Col sm="6" md="3">
            <Nav vertical>
              <NavItem>
                <NavLink href="#" className="font-weight-bold">Produkte</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="https://www.anypayload.com">anypayload</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="https://pictury.at">Pictury</NavLink>
              </NavItem>
            </Nav>
          </Col>

          <Col sm="6" md="3">
            <Nav vertical>
              <NavItem>
                <NavLink to="/kontakt" tag={Link} className="font-weight-bold">Kontakt</NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/datenschutz" tag={Link} activeClassName="active">Datenschutz</NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/impressum" tag={Link} activeClassName="active">Impressum</NavLink>
              </NavItem>
            </Nav>
          </Col>
        </Row>
        <Row>
          <Col className="small">
            <p className="font-weight-bold pl-3">&copy; website and design by thomas schmidleithner</p>
          </Col>
        </Row>
      </Container>
    </footer>
  </div>

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer.js